export const ETHLogo = () => (
  <div className="border border-neutral-300/20 flex flex-row items-center gap-x-2 p-[3px] pr-[5px] rounded-full">
    <img
      src="/eth.png"
      alt="eth logo"
      className="rounded-full h-7 w-auto object-contain hover:scale-110 transition-all duration-200"
    />
    <div className="text-sm font-bold">ETH</div>
  </div>
);
export const ArmyLogo = () => (
  <div className="border border-neutral-300/20 flex flex-row items-center gap-x-2 p-[3px] pr-[5px] rounded-full">
    <img
      src="/PNG/pic-bianco.png"
      alt="eth logo"
      className="rounded-full h-7 w-auto object-contain hover:scale-110 transition-all duration-200"
    />
    <div className="text-sm font-bold">$ARMY</div>
  </div>
);